import React from 'react';

const LastSyncDisplay = ({ lastSync, loading }) => {
    const twentyFour = 24 * 60 * 60 * 1000;
    const threeDays = 3 * 24 * 60 * 60 * 1000;

    if (loading) {
        return (
            <div className="last-sync-container">
                <span className='last-sync-loading'></span>
                Last synced time loading
            </div>
        );
    }

    return (
        <div className="last-sync-container">
            <span className={
                lastSync && lastSync.date
                    ? (new Date() - new Date(lastSync.date) < twentyFour ? 'last-sync-recent' : 
                       (new Date() - new Date(lastSync.date) < threeDays ? 'last-sync-old' : 
                       'last-sync-very-old'))
                    : ''
            }></span>
            Last synced on {lastSync ? new Date(lastSync.date).toLocaleString() : 'No sync data available'}
        </div>
    );
};

export default LastSyncDisplay; 